import { useAppSelector } from '@frontend/common';
import { FeatureTarget, FunctionalityType } from '@frontend/functionality/types';
import { getApplicationIcon } from '@frontend/functionality/utils';
import { useLicenseRepository } from '@frontend/repository';
import { fetchProfile, userStore } from '@frontend/user/redux';
import type { IUser } from '@frontend/user/types';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { useAppDispatch } from '../redux/store';
import { getLink } from './licensed-navbar-item/licensed-navbar-item.controller';

interface ViewProps {
    links: Array<{
        label: string;
        href: string;
        state: { functionalityId: string };
        icon: React.ReactNode;
    }>;
    user?: IUser;
}

const useMobileNavbar = (): ViewProps => {
    const dispatch = useAppDispatch();
    const userState = useAppSelector(useSelector, userStore);
    const [user, setUser] = useState<IUser | undefined>(undefined);
    const { functionalities } = useLicenseRepository();

    const filteredFunctionalities = (functionalities || []).filter(
        (f) => f.target === FeatureTarget.PLATFORM && f.type === FunctionalityType.CORPORATE && f.hidden !== true
    );
    const links = filteredFunctionalities.map((functionality) => {
        const Icon = getApplicationIcon(functionality.application);
        const rawHref = getLink(functionality) || `/${functionality.application}/${functionality.id}`;
        return {
            label: functionality.name,
            href: `${rawHref}?functionalityId=${functionality.id}`,
            state: { functionalityId: functionality.id },
            icon: React.createElement(Icon, { className: 'bg-brand-structure text-background-surface size-5 rounded-md p-1' })
        };
    });

    useEffect(() => {
        dispatch(fetchProfile());
    }, [dispatch]);

    useEffect(() => {
        if (userState.current) setUser(userState.current);
    }, [userState.current]);

    return { links, user };
};

export default useMobileNavbar;
